import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Home from './components/Home';
import Login from './components/Login';
import Recover from './components/Recover';
import Audiences from './components/Audiences';
import Parameters from './components/Parameters';
import AudienceNew from './components/AudienceNew';
import PersonTypes from './components/parameters/PersonTypes';
import AudienceTypes from './components/parameters/AudienceTypes';
import AudienceCategories from './components/parameters/AudienceCategories';
import AudienceMotives from './components/parameters/AudienceMotives';
import ResultTypes from './components/parameters/ResultTypes';
import ResultModalities from './components/parameters/ResultModalities';
import InhibitionTypes from './components/parameters/InhibitionTypes';
import Defensories from './components/parameters/Defensories';
import Dependencies from './components/parameters/Dependencies';
import DependencyTypes from './components/parameters/DependencyTypes';
import Rooms from './components/parameters/Rooms';
import Servers from './components/parameters/Servers';
import Ofijus from './components/admin/Ofijus';
import Units from './components/admin/Units';
import Levels from './components/admin/Levels';
import Users from './components/admin/Users';
import Judges from './components/persons/Judges';
import Functionaries from './components/persons/Functionaries';
import Inhibitions from './components/utilities/Inhibitions';
import Turns from './components/utilities/Turns';
import Reports from './components/Reports';
import AudienceWork from './components/AudienceWork';
import LicenceTypes from './components/parameters/LicenceTypes';
import Licences from './components/utilities/Licences';
import PrivateRoute from './components/auth/PrivateRoute';
import AudienceTodayList from './components/audiences/AudienceTodayList';
import Recuses from './components/utilities/Recuses';
import ResetPassword from './components/ResetPassword';
import VideoPlayer from './components/VideoPlayer';
import Agenda from './components/Agenda';
import FourZeroFour from './components/layout/FourZeroFour';
import { AGENDA_VER, FUNCIONARIOS_LISTAR, INHIBICIONES_LISTAR, JUECES_LISTAR, LICENCIAS_LISTAR, NIVELES_MODIFICAR, OFIJUS_LISTAR, PARAMETROS_LISTAR, RECUSACIONES_LISTAR, REPORTES_VER, SOLICITUDES_CREAR, SOLICITUDES_MODIFICAR, TURNOS_LISTAR, UNIDADES_LISTAR, USUARIOS_LISTAR } from './data/objects';
import AudienceView from './components/AudienceView';
import Characters from './components/parameters/Characters';
import Start from './components/Start';

const AppRoutes = () => {
    return (
        <Switch>
          <Route exact path="/iniciar-sesion" component={Login} />
          <Route exact path="/recuperar-contrasena" component={Recover} />
          <Route exact path="/reset-password/:token" component={ResetPassword} />
    
          <PrivateRoute exact path="/reportes" component={Reports} object={REPORTES_VER} />
          
          <PrivateRoute exact path="/parametros" component={Parameters} object={PARAMETROS_LISTAR} />
          <PrivateRoute exact path="/parametros/audiencia-categorias" component={AudienceCategories} object={PARAMETROS_LISTAR} />
          <PrivateRoute exact path="/parametros/audiencia-tipos" component={AudienceTypes} object={PARAMETROS_LISTAR} />
          <PrivateRoute exact path="/parametros/audiencia-motivos-cancelacion" component={AudienceMotives} object={PARAMETROS_LISTAR} />
          <PrivateRoute exact path="/parametros/resultado-tipos" component={ResultTypes} object={PARAMETROS_LISTAR} />
          <PrivateRoute exact path="/parametros/resultado-modalidades" component={ResultModalities} object={PARAMETROS_LISTAR} />
          <PrivateRoute exact path="/parametros/persona-tipos" component={PersonTypes} object={PARAMETROS_LISTAR} />
          <PrivateRoute exact path="/parametros/caracteres" component={Characters} object={PARAMETROS_LISTAR} />
          <PrivateRoute exact path="/parametros/persona-inhibicion-tipos" component={InhibitionTypes} object={PARAMETROS_LISTAR} />
          <PrivateRoute exact path="/parametros/unidad-defensorias" component={Defensories} object={PARAMETROS_LISTAR} />
          <PrivateRoute exact path="/parametros/unidad-dependencias" component={Dependencies} object={PARAMETROS_LISTAR} />
          <PrivateRoute exact path="/parametros/unidad-dependencia-tipos" component={DependencyTypes} object={PARAMETROS_LISTAR} />
          <PrivateRoute exact path="/parametros/salas" component={Rooms} object={PARAMETROS_LISTAR} />
          <PrivateRoute exact path="/parametros/servidores" component={Servers} object={PARAMETROS_LISTAR} />
          <PrivateRoute exact path="/parametros/licencia-tipos" component={LicenceTypes} object={PARAMETROS_LISTAR} />
          
          <PrivateRoute exact path="/administracion/ofijus" component={Ofijus} object={OFIJUS_LISTAR} />
          <PrivateRoute exact path="/administracion/unidades" component={Units} object={UNIDADES_LISTAR} />
          <PrivateRoute exact path="/administracion/niveles" component={Levels} object={NIVELES_MODIFICAR} />
          <PrivateRoute exact path="/administracion/usuarios" component={Users} object={USUARIOS_LISTAR} />
          
          <PrivateRoute exact path="/personas/funcionarios" component={Functionaries} object={FUNCIONARIOS_LISTAR} />
          <PrivateRoute exact path="/personas/jueces" component={Judges} object={JUECES_LISTAR} />
          
          <PrivateRoute exact path="/utilidades/inhibiciones" component={Inhibitions} object={INHIBICIONES_LISTAR} />
          <PrivateRoute exact path="/utilidades/turnos" component={Turns} object={TURNOS_LISTAR} />
          <PrivateRoute exact path="/utilidades/recusaciones" component={Recuses} object={RECUSACIONES_LISTAR} />
          <PrivateRoute exact path="/utilidades/licencias" component={Licences} object={LICENCIAS_LISTAR} />
          
          <PrivateRoute exact path="/" component={Home} />
          <PrivateRoute exact path="/audiencias" component={Audiences} />
          <PrivateRoute exact path="/audiencias/nueva-solicitud" component={AudienceNew} object={SOLICITUDES_CREAR} />
          <PrivateRoute exact path="/audiencias/calendario" component={Agenda} object={AGENDA_VER} />
          <PrivateRoute exact path="/audiencias/:date/dia" component={AudienceTodayList} />
          <PrivateRoute exact path="/audiencias/:id/formulario-trabajo/:component" component={AudienceWork} object={SOLICITUDES_MODIFICAR} />
          <PrivateRoute exact path="/audiencias/:id/ver" component={AudienceView} />
          <PrivateRoute exact path="/audiencias/:id/videos" component={VideoPlayer} />
          <Route exact path="/audiencias/:type" component={Start} />
          

          <Route component={FourZeroFour} />
        </Switch>
    );
};

export default AppRoutes;